<template>
  <div class="salary-wrapper">
    <div class="salary-header">
      <div class="income-card-box">
        <div class="income-card">
          <div class="salary-total">
            <div class="total">
              <div class="type">累计收入 (元)</div>
              <div class="cash" :class="{'zero': parseFloat(totalMoney) == 0}">{{totalMoney}}</div>
            </div>
            <!-- 不显示可提现
            <div class="total">
              <div class="type">可提现金额 (元)</div>
              <div class="cash" :class="{'zero': parseFloat(balance) == 0}">{{balance}}</div>
            </div>
            -->
            <!-- <button class="take-cash-button" :disabled="parseFloat(balance) == 0" @click="withdrawMoney">提现</button> -->
          </div>

          <div class="accumulative-income"></div><!--累计收入:<span :class="{'zero': parseFloat(totalMoney) == 0}">{{totalMoney}}</span>(元)-->

        </div>
      </div>
      <div class="income-classification">
        <div class="income-type">
          <div class="type-name">医事服务费</div>
          <div class="income">累计 <span :class="{'zero': parseFloat(money) == 0}">{{money}}</span> (元)</div>
        </div>
        <div class="income-type">
          <div class="type-name">喜乐积分<icon icon-class="question" @click.native="coinTipsShow = true"></icon></div>
          <div class="income">累计 <span :class="{'zero': parseFloat(bonus) == 0}">{{bonus}}</span> 个</div>
        </div>
      </div>
    </div>
    <div class="salary-list">
      <div class="salary-item" v-for="(item, index) in salaryLog" :key="index">
        <div class="salary-type">
          <div class="type">{{item.type | salaryTypeFilter}}</div>
          <div class="date">{{item.create_time | dateFilter}}</div>
        </div>
        <div class="money">{{item.type == 3 ? '-' : '+'}} {{item.money}}</div>
      </div>
      <div class="data-loading" v-if="dataDone && !isOver"><van-loading type="spinner" size="14px">加载中...</van-loading></div>
      <div class="data-finish" v-if="dataDone && isOver">无更多数据</div>
    </div>
    <x-dialog title="什么是喜乐积分？" v-if="coinTipsShow">
      <div class="tips-text">喜乐积分是喜乐医生的线上虚拟积分<br>喜乐积分详细兑换规则请<a :href="`tel:${servicePhone}`"> 咨询客服 </a></div>
      <div class="back"><button class="back-button" @click="coinTipsShow = false">返回</button></div>
    </x-dialog>
  </div>
</template>

<style lang="less" scoped>
  .salary-wrapper{
    .salary-header{
      .income-card-box{
        padding: 40px 20px 0;
        background: @linear;
        height: 158px;
        .income-card{
          background: #FFF;
          border-radius: 5px;
          box-shadow:0px 4px 20px 0px rgba(0,0,0,0.1);
          .salary-total{
            padding: 23px 20px 20px;
            padding: 23px 20px 0px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .total{
              .type{
                font-size: 14px;
                line-height: 14px;
                color: @black;
              }
              .cash{
                margin-top: 10px;
                font-size: 32px;
                line-height: 32px;
                color: @xile;
                font-weight: bold;
                &.zero{
                  color: #999;
                }
              }
            }
            .take-cash-button{
              @button-base();
              width: 80px;
              height: 32px;
            }
          }
          .accumulative-income{
            height: 50px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            color: @black;
            line-height: 14px;
            padding: 0 20px;
            span{
              margin: 0 6px 0 4px;
              font-size: 17px;
              line-height: 15px;
              font-weight: bold;
              color: @xile;
              &.zero{
                color: #999;
              }
            }
          }
        }
      }
      .income-classification{
        position: relative;
        margin-top: 32px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0 20px;
        height: 70px;
        &::after{
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 1px;
          height: 30px;
          background: #EEE;
        }
        .income-type{
          width: 50%;
          padding-left: 30px;
          &:first-child{
            padding-left: 20px;
          }
          .type-name{
            font-size: 14px;
            line-height: 14px;
            color: @black;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            svg{
              position: relative;
              top: -2px;
              font-size: 14px;
              color: #AAA;
            }
          }
          .income{
            margin-top: 6px;
            font-size: 13px;
            line-height: 13px;
            span{
              font-size: 15px;
              line-height: 15px;
              font-weight: bold;
              color: @xile;
              margin: 0 2px;
              &.zero{
                color: #999;
              }
            }
          }
        }
      }
    }
    .salary-list{
      border-top: 12px solid #F7F7F7;
      .salary-item{
        margin-left: 23px;
        border-bottom: 1px solid #EEE;
        height: 66px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 24px;
        .salary-type{
          .type{
            font-size: 14px;
            line-height: 14px;
            color: @black;
          }
          .date{
            margin-top: 8px;
            font-size: 13px;
            line-height: 13px;
            color: #999;
          }
        }
        .money{
          font-size: 16px;
          line-height: 16px;
          color: @black;
          &.minus{
            color: #999;
          }
        }
      }
    }

    // 弹窗
    .tips-text{
      text-align: center;
      margin: 40px 0;
      font-size: 14px;
      line-height: 24px;
      color: #666;
      font-weight: bold;
      a{
        color: #666;
        text-decoration: underline;
      }
    }
    .back{
      margin: 0 auto 32px;
      width: 240px;
      .back-button{
        @button-base();
        width: 100%;
        height: 36px;
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        dataDone: false,
        curentPage: 1,
        // 提现金额
        balance: 0,
        // 总计
        totalMoney: 0,
        // 喜乐币
        bonus: 0,
        // 医事服务费
        money: 0,
        salaryLog: [],
        coinTipsShow: false,
        isOver: false,
        timer: null,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      servicePhone() {
        return this.$store.state.servicePhone;
      }
    },
    components: {
      xDialog
    },
    created() {
      this.getData();
    },
    mounted() {
      window.addEventListener('scroll', this.scrollToLoad);
    },
    beforeDestory() {
      window.removeEventListener('scroll', this.scrollToLoad);
    },
    methods: {
      getData() {
        this.$root.post('/getMoneyLog', {
          doc_id: this.userInfo.user_id,
          page: this.curentPage,
          count: 20,
        }).then(data => {
          this.dataDone = true;
          this.balance = data.balance || 0;
          this.totalMoney = data.total_money || 0;
          this.money = data.money || 0;
          this.bonus = data.bonus || 0;
          this.salaryLog = [...this.salaryLog, ...data.log_info];
          this.isOver = data.is_over == 1 ? true : false;
          console.log(data);
        })
      },
      scrollToLoad() {
        if(!this.isOver) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            let pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight);
            let viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
            let scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            if(pageHeight - viewportHeight - scrollHeight < 20) {
              this.curentPage ++;
              this.getData();
            }
          }, 200);
        }
      },
      withdrawMoney() {
        this.$router.push('/doctor/withdraw');
      }
    },
    filters: {
      salaryTypeFilter(type) {
        switch(type) {
          case 1: return '医事服务费';break;
          case 2: return '喜乐币';break;
          case 3: return '微信提现';break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Mine/salary.vue